'use strict';


var Emitter = require('cjs-emitter'),

    serial   = require('cjs-async/serial'),

    setupKeyCode = require('stb-keys').set,

    daemon = new Emitter(),

    pluginList    = [],
    loadedPlugins = {},

    apiLink = null,
    keydownTimeoutId;


function pluginOnLoad ( config, plugin ) {
    if ( typeof loadedPlugins[plugin.name] === 'undefined' ) {
        loadedPlugins[plugin.name] = 1;
        pluginList.push(plugin);
    }
}


function saveSettings ( config, callback ) {
    core.backend.request('users/' + core.backend.session.userId + '/settings', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'PUT',
        onload: function ( error, response ) {
            core.backend.settings[config.name] = config.value;
            window.extendCorePrototype('backend', core.backend);
            callback(error, response);
        },
        onerror: function () {
            callback(true);
        },
        body: config.name + '=' + config.value
    });
}


function uniqueGetter ( name ) {
    /* eslint no-invalid-this: 0 */
    return function ( callback ) {
        var self = this,
            pluginStorage = core.dependencyManager.getPluginStorage(name);

        setTimeout(function () {
            if ( self.data ) {
                console.log(JSON.stringify(self.data));
                Object.keys(self.data).forEach(function ( key ) {
                    self.data[key] = pluginStorage.getItem(key) || self.data[key];
                });
                console.log(JSON.stringify(self.data));

                callback(null, self.data);
            } else {
                callback();
            }
        }, 0);
    };
}

function uniqueSaver ( name ) {
    return function ( callback ) {
        var self = this,
            pluginStorage = core.dependencyManager.getPluginStorage(name);

        setTimeout(function () {
            console.log(JSON.stringify(self.data));
            Object.keys(self.data).forEach(function ( key ) {
                pluginStorage.setItem(key, self.data[key]);
            });

            callback();
        }, 0);
    };
}


function loadTree ( tree, callback ) {
    var loaders, map, index;

    loaders = [];
    map = {};
    index = 0;

    Object.keys(tree).forEach(function ( name ) {
        map[name] = index;
        console.log(name + ' in tree, index: ' + index);
        ++index;
        if ( tree[name] !== null ) {
            if ( Array.isArray(tree[name]) ) {
                tree[name].forEach(function ( nameInner ) {
                    map[nameInner] = index;
                    console.log(nameInner + ' in tree, index: ' + index);
                    ++index;
                });
            }
        }
    });

    // if not in tree, gather all others plugins
    if ( index < pluginList.length ) {
        while ( index < pluginList.length ) {
            if ( !map[pluginList[index].name] ) {
                console.log('not found in tree ' + pluginList[index].name);
                map[pluginList[index].name] = index;
                ++index;
            }
            console.log(index);
        }
    }

    loaders.length = pluginList.length;
    pluginList.forEach(function ( plugin ) {
        loaders[map[plugin.name]] = function ( done ) {
            plugin.instance.onSettingsInit({
                api: apiLink,
                options: plugin.options,
                storage: core.dependencyManager.getPluginStorage(plugin.name),
                path: core.packageMap[plugin.packageName].url + '/../'
            }, function ( error, data ) {
                var saver = null,
                    getter = null;

                if ( data.options ) {
                    data.options.forEach(function ( option ) {
                        if ( typeof option.data !== 'undefined') {
                            if ( typeof option.saver === 'undefined' ) {
                                if ( saver === null ) {
                                    saver = uniqueSaver(plugin.name);
                                }

                                option.saver = saver;
                            }

                            if ( typeof option.getter === 'undefined' ) {
                                if ( getter === null ) {
                                    getter = uniqueGetter(plugin.name);
                                }

                                option.getter = getter;
                            }
                        }
                    });
                }

                if ( data.content ) {
                    data.content.forEach(function ( item ) {
                        if ( item.type === 'option' && typeof item.data !== 'undefined') {
                            if ( typeof item.saver === 'undefined' ) {
                                if ( saver === null ) {
                                    saver = uniqueSaver(plugin.name);
                                }

                                item.saver = saver;
                            }

                            if ( typeof item.getter === 'undefined' ) {
                                if ( getter === null ) {
                                    getter = uniqueGetter(plugin.name);
                                }

                                item.getter = getter;
                            }
                        }
                    });
                }
                done(error, data);
            });
        };
        loaders[map[plugin.name]].toString = function () {
            return plugin.name;
        };
    });

    loaders = loaders.filter(function ( loader ) {
        return !!loader;
    });

    serial(loaders, callback);
}


function fulfillApiObject ( api ) {
    var gSTB = top.gSTB;

    api.actions = api.actions || {};
    api.actions.reload = core.reload;
    api.actions.reboot = core.reboot;
    api.actions.loadEmbedPortal = function () {
        location.href = 'file:///home/web/services.html';
    };
    api.actions.clearUserData = function () {
        // eslint-disable-next-line new-cap
        gSTB.ResetUserFs();
        // eslint-disable-next-line new-cap
        gSTB.SetEnv('{"language":"en"}');
    };
    api.actions.resetUserFs = function () {
        // eslint-disable-next-line new-cap
        gSTB.ServiceControl('local-config', 'reset');
    };

    api.getters = api.getters || {};
    api.getters.environment = function ( callback ) {
        var self = this,
            variables = Object.keys(self.environment);

        setTimeout(function () {
            var emptyResult = false,
                undefinedVariables = [],
                data;

            variables.forEach(function ( name ) {
                if ( typeof core.environment[name] === 'undefined' ) {
                    console.log('not in core.environment ' + name);
                    undefinedVariables.push(name);
                } else if ( core.environment[name] ) {
                    self.environment[name] = core.environment[name];
                } else {
                    core.environment[name] = self.environment[name];
                }
            });

            if ( undefinedVariables.length > 0 ) {
                if ( gSTB ) {
                    // eslint-disable-next-line new-cap
                    data = JSON.parse(gSTB.GetEnv(JSON.stringify({
                        varList: undefinedVariables
                    })));

                    variables.forEach(function ( name ) {
                        if ( data.result[name] === '' ) {
                            emptyResult = true;
                        } else {
                            core.environment[name] = self.environment[name] = data.result[name];
                        }
                    });

                    if ( emptyResult ) {
                        // eslint-disable-next-line new-cap
                        gSTB.SetEnv(JSON.stringify(data.result));
                    }
                }
            }
            callback(false, self.environment);
        }, 0);
    };

    api.savers = api.savers || {};
    api.savers.environment = function ( callback ) {
        var self = this,
            variables = Object.keys(self.environment);

        variables.forEach(function ( name ) {
            core.constructor.prototype.environment[name] = self.environment[name];
        });

        setTimeout(function () {
            if ( gSTB ) {
                // eslint-disable-next-line new-cap
                gSTB.SetEnv(JSON.stringify(self.environment));
            }

            callback();
        }, 0);
    };

    if ( core.backend && core.backend.session && core.backend.session.userId ) {
        api.getters.userSettings = function ( callback ) {
            var self = this;

            setTimeout(function () {
                var value = core.backend.settings[self.variable.name];

                self.variable.value = value;
                callback(false, value);
            }, 0);
        };

        api.savers.userSettings = function ( callback ) {
            saveSettings({
                name: this.variable.name,
                value: this.variable.value
            }, function ( error, data ) {
                if ( !error && data.data === true ) {
                    callback();
                } else {
                    callback(true);
                }
            });
        };
    } else {
        api.getters.userSettings = uniqueGetter('user-settings');
        api.savers.userSettings = uniqueSaver('user-settings');
    }
}

function setKeydownHandler () {
    // TODO: rework application start during system start and remove this hardcode
    core.taskManager.hideAll();
    core.intent({
        action: 'setup'
    }, function ( error ) {
        console.log(error);
    });
}


daemon.once('launcher:ready', function () {
    // Ctrl+F9, SET button on MAG remote control
    core.addListener('keydown:' + setupKeyCode, function () {
        clearTimeout(keydownTimeoutId);

        keydownTimeoutId = setTimeout(setKeydownHandler, core.environment.onFocusDebounceTimeout)
    });
});


module.exports = {
    onAppInit: function ( config, appInit ) {
        appInit(null, {
            init: function ( api, callback ) {
                var dependencies = {},
                    tree;

                core.packages.forEach(function ( packageData ) {
                    if ( packageData.tree && packageData.name === 'settingsStructure' ) {
                        // plugin settings structure
                        tree = packageData.tree;
                        // TODO: need to rework settings customization
                        // if ( config.options && config.options.tree ) {
                        //     tree = JSON.parse(config.options.tree.trim());
                        // }
                    }

                    if ( packageData.tuner ) {
                        // plugin for settings application
                        dependencies[packageData.packageName] = packageData.version;
                    }
                });

                fulfillApiObject(api);
                apiLink = api;

                pluginList.splice(0);
                core.dependencyManager.load({
                    dependencies: dependencies,
                    dependencyReady: pluginOnLoad,
                    done: function () {
                        loadTree(tree, function ( error, data ) {
                            loadedPlugins = {};
                            callback(error, data);
                        });
                    }
                });
            }
        });
    },
    onInit: function ( config, callback ) {
        callback(null, daemon);
    }
};
